export default __webpack_public_path__ + "static/media/bffe77c0bd8caa3a20adfd6b06d74f29.4ab02cdd.jpeg";